import React from "react"

interface ArrowBackProps {
  className?: string
  size?: string | number
}

const ArrowBack: React.FC<ArrowBackProps> = ({ className, size = "24" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <circle cx="12" cy="12" r="12" fill="#F6F6F6" />
      <path d="M13.9172 15.7879L10.0833 11.954L13.9172 8.21143" stroke="#067BF2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default ArrowBack
